import { LogoName } from '@/app/components/ui';
import { COBRANDED_PARTNERS } from '@/app/configs/cobrandedPartners';

export const PUBLIC_ROUTES = ['/', '/email', '/404', '/maintenance'];

export function getLogoName(orders?: { channel?: string }[]) {
  if (!orders?.length) return;
  const firstChannel = orders[0].channel;
  if (!firstChannel || !(firstChannel in COBRANDED_PARTNERS)) return;
  return orders.every((order) => order.channel === firstChannel)
    ? (COBRANDED_PARTNERS[firstChannel].logo as LogoName)
    : undefined;
}

export enum Partner {
  business = 'business',
  demo = 'demo',
  essence = 'essence',
}

export interface PartnerConfig {
  getOrders: boolean;
  invalidStep: string;
  successStep: string;
  completedStep: string;
  publicRoutes?: string[];
  overrideLocale?: string;
  supportEmail?: string;
  // Routes to ensure new data is fetched
  fetchDataRoutes?: string[];
  // Hydrate order state from session data
  // Used by essence, for example, since the user doesn't choose an order to continue
  hydrateOrderState?: boolean;
  // Check if the user is eligible
  checkEligibility?: boolean;
}

export const config: Record<Partner, PartnerConfig> = {
  demo: {
    getOrders: false,
    invalidStep: '/',
    successStep: '/',
    completedStep: '/',
    publicRoutes: PUBLIC_ROUTES,
  },
  essence: {
    getOrders: true,
    invalidStep: '/invalid-email',
    successStep: '/select',
    completedStep: '/summary',
    overrideLocale: 'en',
    supportEmail: 'partnersupport@ouraring.com',
    fetchDataRoutes: ['/select'],
    publicRoutes: PUBLIC_ROUTES,
    hydrateOrderState: true,
    checkEligibility: true,
  },
  business: {
    getOrders: true,
    invalidStep: '/invalid-email',
    successStep: '/account',
    // the completed step is the "account" page for business
    // because the user can choose to view their "order"
    completedStep: '/account',
    supportEmail: 'partnersupport@ouraring.com',
    fetchDataRoutes: ['/account'],
    publicRoutes: PUBLIC_ROUTES,
  },
  //add more configs for each "tenant" or "partner"...
};
